module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacidade",
	"footer.privacy.url": "https://www.grohe.pt/pt_pt/privacidade.html",
	"footer.disclaimer.text": "Disclaimer",
	"footer.disclaimer.url": "https://www.grohe.pt/pt_pt/imprimir.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "Configurador GROHE WaterSystems",
	"homepage.introtext": "Responda às perguntas abaixo e configure o Watersystem GROHE que melhor se ajusta às suas necessidades",
	"homepage.buttonStart": "Iniciar",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Página não encontrada",
	"404.link.goBack": "Volte para a página principal",
	"configurator.button.seeResults": "Veja os resultados",
	"question1.question": "Dispõe de um fornecimento de água quente e fria na sua cozinha?",
	"question1.option1.text": "Eu tenho um fornecimento de água quente e fria na minha cozinha",
	"question1.option2.text": "Eu tenho apenas um fornecimento de água fria",
	"question2.question": "Qual é o tipo de água que procura?",
	"question2.option1.text": "água a ferver para preparar comidas e bebidas",
	"question2.option2.text": "Água fresca e gaseificada para beber",
	"question2.option3.text": "Água fresca e gaseificada, assim como água a ferver",
	"question3.question": "Deseja manter a sua torneira de cozinha?",
	"question3.option1.text": "Sim, eu quero mantê-la",
	"question3.option2.text": "Eu quero instalar uma nova",
	"question4.question": "Qual deve ser a sua torneira principal?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Qual é o tipo de bica que prefere?",
	"question5.option1.text": "Bica em L",
	"question5.option2.text": "Bica em U",
	"question5.option3.text": "Bica em C",
	"question6.question": "Qual é tipo de acabamento que prefere?",
	"question6.option1.text": "Cromado",
	"question6.option2.text": "Supersteel",
	"question7.question": "Selecione o tamanho do boiler que precisa",
	"question7.option1.text": "Tamanho M (3 Litros)",
	"question7.option2.text": "Tamanho L (5.5 Litros)",
	"results.title": "{productGroupsCount, plural, \none {O seu resultado} \nother {Os seus resultados}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Para uma correta instalação também irá precisar de:",
	"results.newConfiguration.title": "Deseja configurar um novo water system?",
	"results.newConfiguration.buttonText": "Configure um novo water system",
	"results.product.number": "Número do produto: #{number}",
	"results.product.button.productInformation": "Informação acerca do produto",
	"results.product.button.dealerLocator": "Encontrar um showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Informação acerca do produto",
	"results.product.dealer": "Encontrar um showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/water.pt_pt.json
// module id = 792
// module chunks = 0